import { createElement } from "react";
import { SimpleAlert } from "../components/Alerts/Alerts";
import { ALERT_ICON_TYPE_ERROR } from "../utils/constants";
import { ackOptimisticSwitch } from "./ackOptimisticSwitch";
import OptimisticSwitchFailureAlertBody from "./FailureAlertBody";

import { LaunchError } from "../utils/errors";
import { store } from "../app/store";

export const toOptimisticSwitchPayload = ({ operationId, copy }) => ({
  operationId,
  title: copy?.title || "",
  intro: copy?.intro || "",
  emailSubject: copy?.emailSubject || "",
  kind: copy?.kind || "",
  action: copy?.action || "",
  name: copy?.name || "",
});

export const createOptimisticSwitchOperationId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `optimistic-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const reportOptimisticSwitchFailure = ({
  operationId,
  copy,
  error,
} = {}) => {
  store.dispatch(
    LaunchError(
      error instanceof Error
        ? error
        : new Error(copy?.title || "Optimistic switch failed"),
      false,
      [],
      {
        functionName: "reportOptimisticSwitchFailure",
        capture: "exception",
        context: { operationId },
      }
    )
  );
  SimpleAlert({
    title: copy?.title || "Error",
    html: createElement(OptimisticSwitchFailureAlertBody, { copy, error }),
    icon: ALERT_ICON_TYPE_ERROR,
  });
  ackOptimisticSwitch(operationId);
};

export const runOptimisticSwitch = async ({
  applyOptimistic,
  revertOptimistic,
  action,
  copy,
  persistRetry = true,
}) => {
  const operationId = persistRetry ? createOptimisticSwitchOperationId() : "";
  applyOptimistic?.();

  try {
    const result = await action({ operationId, copy });
    if (result?.ok) return result;

    revertOptimistic?.();
    reportOptimisticSwitchFailure({
      operationId: result?.operationId || operationId,
      copy,
      error: result?.error,
    });
    return result || { ok: false, operationId };
  } catch (error) {
    revertOptimistic?.();
    reportOptimisticSwitchFailure({
      operationId,
      copy,
      error,
    });
    return { ok: false, operationId, error };
  }
};
